import { forwardRef } from "react";
import { PopoverTrigger, Box, type BoxProps } from "@hightouch/htui";

type PopoverTriggerButtonProps = Omit<BoxProps, "aria-label"> & {
  "aria-label": string;
};
/**
 * Render `PopoverTrigger` with an unstyled button as the child.
 *
 * For accessibility compliance, `PopoverTrigger` requires the child is a focusable element.
 */
export const PopoverTriggerButton = forwardRef<
  HTMLButtonElement,
  PopoverTriggerButtonProps
>(function PopoverTriggerButton({ children, ...props }, ref) {
  return (
    <PopoverTrigger>
      <Box
        ref={ref}
        as="button"
        cursor="pointer"
        lineHeight="0"
        textAlign="left"
        p="0"
        borderRadius="md"
        _focus={{ outline: "none" }}
        _focusVisible={{ boxShadow: "outline" }}
        {...props}
      >
        {children}
      </Box>
    </PopoverTrigger>
  );
});
